$(() => {
  var adjust = function () {
    var $window = $(window)
    var wWidth = window.innerWidth
    var main = $('.post__wrapper')
    var side = $('.post__widget--fixed')

    // 幅が901以上の処理
    if (wWidth > 900) {
      // 各コンテンツのステータス取得
      var sTop = $window.scrollTop()
      var mainOffset = main.offset().top
      var mainHeight = main.innerHeight()
      var sideHeight = side.innerHeight()
      var sideWidth = side.width()

      // 追従時に開ける距離
      var topSpace = 30

      // スクロールTOPからの位置調整用の変数
      var adjustmentVal

      if (wWidth > 1200) {
        adjustmentVal = Math.abs($('.header__gnav').height() + topSpace)
      } else {
        adjustmentVal = Math.abs($('.header__head').height() + topSpace)
      }

      // 追従が開始する位置
      var fixed_stertPosition = sTop + adjustmentVal

      // 追従が終了する位置
      var adjust_endPosition = (mainHeight + mainOffset) - sideHeight

      // コンテンツ部分がサイドより高さがある場合のみ追従する ( この処理必要？？？ )
      if (mainHeight > sideHeight) {
        // 固定範囲内 fixed
        if ((mainOffset < fixed_stertPosition) && (fixed_stertPosition < adjust_endPosition)) {
          side.css({
            'width': sideWidth,
            'position': 'fixed',
            'top': adjustmentVal
          })
        }
        // 固定範囲外 absolute
        else if (fixed_stertPosition >= adjust_endPosition) {
          side.css({
            'width': sideWidth,
            'position': 'absolute',
            'top': adjust_endPosition
          })
        }
        // 初期値
        else {
          side.css({
            'width': '',
            'position': '',
            'top': ''
          })
        }
      }
    }

    // 幅が900以下でリサイズされた時cssが設定されていたら解除
    else {
      side.css({
        'width': '',
        'position': '',
        'top': ''
      })
    }
  }

  $(window).on('load resize scroll', adjust)
})
